import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Result } from "antd";
import { useSelector } from "react-redux";
import LoginAxios from "../api/LoginAxios";
import { processIframes } from "../IframeHelper";
import { useDispatch } from "react-redux";
import { resetNotifications } from "../store/slices/notificationSlice";
const SessionExpired = () => {
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state?.user?.data);
  const leftMenuNames = userInfo?.left_menu;
  const [redirect, setRedirect] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetNotifications());
    handleLogout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (redirect) {
      const timer = setTimeout(() => {
        navigate("/");
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [redirect, navigate]);

  const handleLogout = async () => {
    try {
      const res = await LoginAxios.get("/logout/");
      await safeProcessIframes(leftMenuNames);
      localStorage.removeItem("token");
      localStorage.clear();
      console.log(res);
      setRedirect(true);
    } catch (err) {
      console.error("Logout failed, error:", err);
      await safeProcessIframes(leftMenuNames);
      localStorage.removeItem("token");
      localStorage.clear();
      setRedirect(true);
    }
  };

  const safeProcessIframes = async (menuNames) => {
    try {
      await processIframes(menuNames, dispatch);
    } catch (iframeError) {
      console.error("Error in processIframes:", iframeError);
      localStorage.removeItem("token");
      localStorage.clear();
      setRedirect(true);
    }
  };

  return (
    <div style={{ display: "grid", placeItems: "center", height: "100vh" }}>
      <Result
        status="warning"
        title="Your Session has been expired, Please Re-Login"
        extra={
          <p style={{ fontSize: "16px", fontWeight: "400" }}>
            You will be redirected to login, please wait...
          </p>
        }
      />
    </div>
  );
};

export default SessionExpired;
